export default {
  global: {
    colors: {
      brand: '#298EE6',
      'brand-dark': '#1774C4',
      'brand-light': '#56A6EB',
      text: '#1A1A1A',
      'text-weak': '#595959',
      'text-xweak': '#B8B8B8',
      background: '#FFFFFF',
      'background-alt': '#F2F2F2',
      border: '#D8D8D8',
      'border-weak': '#E6E6E6',
      focus: '#298EE6',
      control: '#FFFFFF',
      'control-disabled': '#F2F2F2'
    },

    font: {
      family: "'Manrope', -apple-system, BlinkMacSystemFont, sans-serif",
      size: '16px',
      weight: 400,
      height: '24px'
    },

    input: {
      weight: 400,
      border: {
        color: 'border-weak',
        radius: '12px'
      },
      padding: {
        vertical: '12px',
        horizontal: '16px'
      }
    },

    button: {
      border: {
        radius: '12px'
      },
      padding: {
        vertical: '12px',
        horizontal: '24px'
      },
      primary: {
        color: '#FFFFFF'
      }
    },

    checkBox: {
      border: {
        color: 'border'
      },
      size: '24px'
    },

    radioButton: {
      size: '24px'
    },

    drop: {
      border: {
        radius: '12px'
      },
      elevation: 'medium',
      zIndex: '200'
    },

    focus: {
      border: {
        color: 'focus'
      },
      shadow: {
        color: 'focus'
      }
    },

    margin: {
      horizontal: '16px',
      vertical: '12px'
    },

    pad: {
      horizontal: '24px',
      vertical: '24px'
    },

    size: {
      xsmall: '24px',
      small: '48px',
      medium: '96px',
      large: '192px',
      xlarge: '384px',
      full: '100%'
    }
  },

  button: {
    default: {
      extend: `
        font-weight: 600;
        border-radius: 12px;
        transition: all 120ms ease;
      `
    },
    primary: {
      extend: `
        background-color: #298EE6;
        color: #FFFFFF;
        border: none;
        font-weight: 600;
        border-radius: 12px;
        transition: background-color 120ms ease;

        &:hover:not(:disabled) {
          background-color: #1774C4;
        }

        &:disabled {
          background-color: #E6E6E6;
          color: #B8B8B8;
          cursor: not-allowed;
        }
      `
    }
  },

  text: {
    xsmall: {
      size: '12px',
      height: '16px'
    },
    small: {
      size: '14px',
      height: '20px'
    },
    medium: {
      size: '16px',
      height: '24px'
    },
    large: {
      size: '20px',
      height: '24px'
    },
    xlarge: {
      size: '24px',
      height: '32px'
    },
    xxlarge: {
      size: '32px',
      height: '40px'
    }
  },

  anchor: {
    fontWeight: 500,
    color: 'brand',
    textDecoration: 'none',
    hover: {
      fontWeight: 500,
      color: 'brand-dark'
    }
  }
}
